export default __webpack_public_path__ + "img/8446f91e9c21a867fab5295e59c1c185.png";